import { useEffect, useState } from "react";
import { className as cx } from "@/helpers/utility/class_name";
import style from "./stage_badge.module.css";

export default function StateBadge({
  titleObj,
  currentState,
}) {
  const [stateCLassList, setStateClassList] = useState('')
  const {state, title, className} = titleObj;

  useEffect(() => {
    //Add class to current state
    const classList = (className, key) => {
      const isCurrentState = key === currentState
      const isPassedState = key < currentState
      const classes = [style[className]]
      if (isCurrentState) classes.push(style.active)
      if (isPassedState) classes.push(style.passed)
      return classes.join(' ')
    }

    setStateClassList(classList(className, state))
  }, [])

  return (
    <li className={cx(style.states, stateCLassList)}>
      <div className={style.icon}></div>
      <p>{title}</p>
    </li>
  );
}